// ADA
window.themeADA = window.themeADA || {};

(function ($) {
  let flagCount = 0;
  var $ = jQuery = $;

  themeADA.initADA = function () {
    function init() {
      productMainPhotoSliderADA()
      logFocusItem()
      hiddenFocus()
      removeMouseClass()
      adaGalleryProduct()
      adaHeader()
      handleDialogs()
      adaProductCategories()
      handleCloseDialogs()
      adaTabProduct()
      productFormADA()
      singleForm()
      faqsADA()
      bannerHeroADA()
      configTabindex()
      productImageADA()
      loginForm()
      productADA()
      testimonialADA()
      collectionSliderADA()
      setTimeout(() => {
        shiftTabScrollUp()
      }, 100)
      browserDetection()
      handleReadPrice()
      focusBestSellersItem()
      toggleOneTrust()
      goToAnchorLink()
    }

    function focusBestSellersItem() {
      const $bestSellers = $('.grid-product__link')
      const $bestSellersScroll = $('.grid--uniform')
      const $bestSellersWrap = $bestSellersScroll.parent()
      $bestSellers.on('focusin', function (ev) {
        const clientRect = ev.currentTarget.getBoundingClientRect()
        const offset = $(ev.currentTarget).offset()
        const wrapOffset = $bestSellersWrap.offset()
        const { height, width } = clientRect
        const $header = $('.header-wrapper')
        const winTop = $(window).scrollTop()
        const bottom = offset.top + height
        const minusHeight = window.innerHeight > 700 ? 50 : 0
        /* scroll window for item go to middle screen when item not all visible vertical axis */
        if (window.innerHeight - $header.height() > height + 50 && ((offset.top < $header.height() && bottom < winTop + window.innerHeight)
          || (bottom > winTop + window.innerHeight - minusHeight && offset.top > $header.height()))) {
          $('html, body').animate({
            scrollTop: winTop + (offset.top - winTop - $header.height() + (winTop + window.innerHeight - bottom)) / 2 + 25
          }, 100)
        }

        /* scroll list position to center when item not all visible horizonal axis */
        // const
        const dynamicOffset = wrapOffset.left - $bestSellersScroll.offset().left
        if (wrapOffset.left > offset.left) {
          $bestSellersWrap.scrollLeft(dynamicOffset + (width - $bestSellersWrap.width()) / 2)
        }
        if (wrapOffset.left + $bestSellersWrap.width() < offset.left + width) {
          $bestSellersWrap.scrollLeft(dynamicOffset + ($bestSellersWrap.width() - width) / 2)
        }
      })

    }


    function logFocusItem() {
      // document.addEventListener('focusin', function () {
      //   console.log('focused: ', $(document.activeElement))
      // }, true);
    }

    function removeMouseClass() {
      $(document).on('keydown', (ev) => {
        const code = ev.keyCode || ev.which
        const keyArr = [9, 13, 37, 38, 39, 40, 36, 35]
        if (keyArr.includes(code)) {
          $('html').addClass(this.noMouseText)
          $('.mouse').removeClass('mouse')
        }
      })

      $(document).on('click', (e) => {
        if (e.screenX !== 0 && e.screenY !== 0) {
          $('html').removeClass(this.noMouseText)
        }
      })
    }

    function hiddenFocus() {
      $(document).on('mousedown', (e) => {
        $('*').removeClass('mouse')
        $(e.target).addClass('mouse').parent().addClass('mouse')
        $(e.target).parents('a,.cont-bound ').addClass('mouse')
        $('.status-focus').removeClass('status-focus')
        $('.focus-status').removeClass('focus-status')
      })
    }

    function adaGalleryProduct() {
      if (!$('.product-section').length) {
        return
      }

      const currentCls = 'current-item'
      const thumbBtn = $('.product__thumb')
      const slidePhoto = $('.product__slide')
      const slidePhotoSelector = '.product__slide'
      const slideTrack = $('.product__thumbs')
      const thumbItemCls = '.product__thumb-item'
      const productThumbSelector = '.product__thumb'
      const startingItem = 'starting-slide'
      const disabledFocusCls = 'disabled-focus'
      const activeVariantCls = 'active-variant'
      let totalShowItem = null
      let lastActiveItemPos = null
      let currentShowItem = null
      const sliderThumbs = $('[data-product-thumbs]')
      const sliderPhotos = $('[data-product-photos]')
      let activeScrollNum = null
      let maxHThumb = null
      let thumbBtnHeight = null
      const slickActiveCls = 'slick-active'
      const zoomImgBtn = $('.product__photo-zoom')
      const pswpCloseBtn = $('.pswp__button--close')
      const productVideoTriggerCls = '.product-video-trigger'
      const currentFocusImgCls = `${slidePhotoSelector}.${slickActiveCls}`
      let controlByInputIndex = false
      const variantInputSelector = '[data-variant-input]'

      keys = {
        tab: 9,
        arrowDown: 40,
        arrowUp: 38,
        arrowLeft: 38,
        arrowRight: 39,
        right: 39,
        enter: 13,
        space: 32,
        esc: 27
      }

      const options = {
        centerPadding: "50px",
        slide: ".active-variant",
        cssEase: "ease",
        dotsClass: "slick-dots",
        appendDots: ".product__photo-dots",
        dots: true,
        arrows: false,
        edgeFriction: 0.35,
        rows: 1,
        rtl: false,
        slide: ".active-variant",
        slidesPerRow: 1,
        speed: 300,
        touchThreshold: 10,
        waitForAnimate: true,
        mobileFirst: true,
        responsive: [
          {
            breakpoint: 769,
            settings: 'unslick'
          },
        ]
      }

      // get show category
      const variantInput = $('.variant-input-wrap input[data-index="option1"]')

      changeAltOfImg()

      function changeAltOfImg() {
        slidePhoto.each((_i, el) => {
          const item = $(el)
          let alt = formatAlt(item)

          if (!item.find(productVideoTriggerCls).length) {
            alt += " Zoom in"
            item.attr('aria-label', alt)
            item.find('img').attr('alt', alt)
          } else {
            // item.find('img').attr('alt', currentAlt + "Play video")
          }
        })

        function formatAlt(item) {
          const currentAlt = item.find('img').attr('alt')
          const sharpPos = currentAlt.lastIndexOf('#') !== -1 ? currentAlt.lastIndexOf('#') : currentAlt.length
          const spacePos = currentAlt.indexOf(' ', sharpPos) !== -1 ? currentAlt.indexOf(' ', sharpPos) : currentAlt.length
          const trimText = currentAlt.substring(sharpPos, spacePos).trim()
          const underscorePos = trimText.indexOf('_')
          if (underscorePos > 0 && underscorePos < trimText.length - 1) {
            return currentAlt.replace(trimText, '').trim()
          }
          return currentAlt
        }

        if ($('.product__thumbs')[0].hasChildNodes()) {
          $('.product__thumb-item').each((_i, el) => {
            const item = $(el)
            const alt = formatAlt(item)
            item.find('img').attr('alt', alt)
            item.find('button').attr('aria-label', alt)

          })
        } else if ($('.product__main-photos-wrapper')[0].hasChildNodes()) {
          $('.product__slide').each((_i, el) => {
            const item = $(el)
            const alt = formatAlt(item)
            item.find('img').attr('alt', alt)
          })
        }
      }

      $(window).on('resize', () => {
        slideTrack.css('max-height', '')
        clearTimeout(this.timeOut)
        if ($(window).innerWidth() < 769) {
          !sliderPhotos.hasClass('slick-initialized') && sliderPhotos.slick(options)

        } else {
          this.timeOut = setTimeout(() => {
            setSlideTrackEqualHeightWithSibling()
          }, 200)
        }
      })

      $(window).on('load', () => {
        // wait window load for get element height
        setSlideTrackEqualHeightWithSibling()
        thumbBtnHeight = 100
        halfActive = Math.ceil(maxHThumb / thumbBtnHeight) / 2
        activeScrollNum = halfActive + Math.ceil(halfActive / 2)
      })

      if (variantInput.length === $(thumbItemCls).length) {
        controlByInputIndex = true
        options.slide = ".product__slide"
      }

      if ($(window).innerWidth() < 769) {
        !sliderPhotos.hasClass('slick-initialized') && sliderPhotos.slick(options)
      }

      // init load item
      if ($('.variant-wrapper').length) {
        variantInput.each((index, el) => {
          const ele = $(el)
          if (ele.attr('checked')) {
            if (!controlByInputIndex) {
              handleProcessValue(ele.val())
            } else {
              handleProcessValue(index)
              // $(productThumbSelector)
              $($(productThumbSelector).get(index)).addClass(currentCls).attr('aria-selected', true)

              if (sliderPhotos.hasClass('slick-initialized')) {
                sliderPhotos.slick('slickGoTo', index)
              }
            }
          }
        })
        // load item base on input value change
        variantInput.on("change", (e) => {
          if (!controlByInputIndex) {
            handleProcessValue(e.target.value)
          } else {
            const targetInput = $(e.currentTarget)
            $(variantInputSelector).each((index, el) => {
              if (targetInput.hasClass('no-reload')) {
                return targetInput.removeClass('no-reload')
              }

              if (targetInput.get(0).id === $(el).get(0).id) {
                $($(productThumbSelector).get(index)).click()
                handleProcessValue(index)
                $(productThumbSelector).removeClass(disabledFocusCls)

                if (sliderPhotos.hasClass('slick-initialized')) {
                  sliderPhotos.slick('slickGoTo', index)
                }
              }
            })
          }
        })
      } else {
        showItemBaseOnValue(value = null, true)
      }

      thumbBtn.on('click', (e) => {
        if (controlByInputIndex) {
          const index = $(e.currentTarget).data('index')
          setCheckedInput(index)
        }

        const id = $(e.currentTarget).data('id')
        moveSlide(id)

      })

      if (controlByInputIndex) {
        sliderPhotos.on('beforeChange', function (_event, _slick, _currentSlide, nextSlide) {
          $(variantInputSelector).prop('checked', false)
          $($(variantInputSelector).get(nextSlide)).prop('checked', true)
        })
      }

      handleControlTab()
      triggerZoomEvent()

      function setSlideTrackEqualHeightWithSibling() {
        slideTrack.next().css('min-height', +slideTrack.next().css('width').replace("px", ""))
        maxHThumb = $(slideTrack.next()).outerHeight(true)
        slideTrack.css('max-height', maxHThumb)
      }

      function handleProcessValue(val) {
        const formatValue = val.toString().toLowerCase().replace(/\s+/g, "-")
        activeVariantValue = formatValue
        showItemBaseOnValue(formatValue, noInput = false, controlByInputIndex)
      }

      function destroySlick() {
        sliderThumbs.hasClass('slick-initialized') && sliderThumbs.slick('destroy')
        sliderPhotos.hasClass('slick-initialized') && sliderPhotos.slick('destroy')
      }

      function focusLargeImgWhenClosePopup() {

        pswpCloseBtn.on('keydown', (e) => {
          const keycode = e.keyCode
          if (keycode === keys.enter || keycode === keys.space) {
            e.preventDefault()
            this.mouseClassAct = true
            pswpCloseBtn.click()
          }
        })
        /* nvda trigger click when keydown */
        pswpCloseBtn.on('click', (e) => {
          pswpCloseBtn.addClass('trigger')
          if (!this.mouseClassAct) {
            $('body').addClass('mouse')
          }
          setTimeout(() => {
            zoomImgBtn.focus()
            this.mouseClassAct = false
          }, 700)

          setTimeout(() => {
            pswpCloseBtn.removeClass('trigger')
          }, 500)
        })

        pswpCloseBtn.on('focus', (e) => {
          // e.stopPropagation()

          if (pswpCloseBtn.hasClass('trigger')) {
            e.preventDefault()
            pswpCloseBtn.blur()
            zoomImgBtn.focus()
            pswpCloseBtn.removeClass('trigger')
          }
        })

        $('.pswp__button').on('keydown', (e) => {
          if (e.keyCode === keys.space) {
            // prevent scroll down
            e.preventDefault()
          }
        })

        $(window).on('keydown', (e) => {
          if (e.keyCode === keys.esc && ('.pswp--open').length) {
            pswpCloseBtn.click().addClass('trigger')
            // setTimeout( ()=> {
            //   zoomImgBtn.focus()
            // }, 100)
            setTimeout(() => {
              pswpCloseBtn.removeClass('trigger')
            }, 500)
          }
        })

        $('.modal__close').on('click', (e) => {
          zoomImgBtn.focus()
        })



        pswpCloseBtn.on('click', (e) => {
          // e.stopPropagation()
          zoomImgBtn.focus()
        })
      }

      function showItemBaseOnValue(value, noInput = false, controlByInputIndex = false) {
        slideTrack.css('margin-top', 0)
        let showIndex = 0

        if (!$(thumbItemCls).length && slidePhoto.length === 1) {
          setTabIndexForThumbBtn(null, null, true)
          return
        }

        if (controlByInputIndex) {
          $(thumbItemCls).addClass(activeVariantCls)
          slidePhoto.addClass(activeVariantCls)

          $(thumbItemCls).each((i, el) => {
            const item = $(el)
            if (i === +value) {
              const thumb = item.find(productThumbSelector)
              const id = thumb.data("id")
              // currentShowItem = thumb

              thumb.attr('aria-selected', true)
              const activePhoto = $(`${slidePhotoSelector}[data-id="${id}"]`)
              activePhoto.addClass(activeVariantCls).addClass('slick-current')
            }

            item.attr("data-show-index", showIndex).removeClass('hidden').addClass(activeVariantCls)
            showIndex += 1
          })

          lastActiveItemPos = $(thumbItemCls).last().position().top
          setTabIndexForThumbBtn(value, true, false, controlByInputIndex = true)
          totalShowItem = showIndex - 1
          // sliderPhotos.hasClass('slick-initialized') && sliderPhotos.slick('refresh')
          return
        }

        if (noInput) {
          $(thumbItemCls).addClass(activeVariantCls)
          slidePhoto.addClass(activeVariantCls)

          $(thumbItemCls).each((i, el) => {
            const item = $(el)
            if (i === 0) {
              item.addClass('slick-current').addClass(startingItem)
              const thumb = item.find(productThumbSelector)
              const id = thumb.data("id")
              thumb.attr('aria-selected', true)
              currentShowItem = thumb

              const activePhoto = $(`${slidePhotoSelector}[data-id="${id}"]`)
              activePhoto.addClass(activeVariantCls).addClass('slick-current')
            }
            item.attr("data-show-index", showIndex).removeClass('hidden').addClass(activeVariantCls)
            showIndex += 1
          })

          lastActiveItemPos = $(thumbItemCls).last().position().top
          setTabIndexForThumbBtn(0, true)
          totalShowItem = showIndex - 1
          sliderPhotos.hasClass('slick-initialized') && sliderPhotos.slick('refresh')
          return
        }

        $(thumbItemCls).removeClass(activeVariantCls)
        slidePhoto.removeClass(activeVariantCls)

        $(thumbItemCls).each((_i, el) => {
          const item = $(el)
          if (item.data("group").indexOf(value) === -1) {
            item.addClass('hidden').removeAttr('data-show-index')
          } else {
            item.attr("data-show-index", showIndex).removeClass('hidden').addClass(activeVariantCls)
            const thumb = item.find(productThumbSelector)
            const id = thumb.data("id")
            if (showIndex === 0) {
              item.addClass(startingItem)
              currentShowItem = thumb
              thumb.attr('aria-selected', true)
            }

            const activePhoto = $(`${slidePhotoSelector}[data-id="${id}"]`)
            activePhoto.addClass(activeVariantCls).addClass('slick-current')

            lastActiveItemPos = item.position().top
            showIndex += 1
          }
        })
        setTabIndexForThumbBtn(0, true)
        totalShowItem = showIndex - 1
        sliderPhotos.hasClass('slick-initialized') && sliderPhotos.slick('refresh')
      }

      function handleControlTab() {
        thumbBtn.on('keydown', (e) => {
          keydownEventListener(e)
        })

        function keydownEventListener(event) {
          const key = event.keyCode
          const eventTarget = $(event.target)
          let indexAttr = 'data-show-index'

          let index = +$(currentShowItem).parents(thumbItemCls).attr('data-show-index')

          if (controlByInputIndex && !currentShowItem) {
            currentShowItem = $($('.current-item').get(0))
            index = currentShowItem.data('index')
          }

          let setDisable = false
          let nextIndex = null
          let nextItem = null

          switch (key) {
            case keys.arrowDown:
              event.preventDefault()

              if (index >= totalShowItem) {
                nextIndex = 0
              } else {
                nextIndex = index + 1
              }

              nextItem = $(`[${indexAttr}="${nextIndex}"]`).find(productThumbSelector)
              moveSlide(nextItem.data("id"))
              currentShowItem = nextItem
              nextItem.focus()
              setDisable = true
              break;

            case keys.arrowUp:
              event.preventDefault()
              if (index <= 0) {
                nextIndex = totalShowItem
              } else {
                nextIndex = index - 1
              }
              nextItem = $(`[${indexAttr}="${nextIndex}"]`).find(productThumbSelector)
              moveSlide(nextItem.data("id"))
              currentShowItem = nextItem
              nextItem.focus()
              setDisable = true
              break;
            case keys.tab:
              eventTarget.click()
              break;

            default:
              break;
          }

          setTimeout(() => {
            if (setDisable) {
              if (controlByInputIndex) {
                setCheckedInput(nextIndex)
              }
              thumbBtn.removeClass(disabledFocusCls)

              // if (eventTarget.data("index") !== nextIndex) {
              //   eventTarget.addClass(disabledFocusCls)
              // } else {
              //   eventTarget.removeClass(disabledFocusCls)
              // }
            }
            setDisable = false
          }, 1)
        }
      }

      function setCheckedInput(index) {
        $(variantInputSelector).removeProp('checked')
        $($(variantInputSelector).get(index)).prop('checked', "checked").addClass('no-reload')
      }

      function triggerZoomEvent() {
        const prevBtnSelector = '.pswp__button--arrow--left'
        const nextBtnSelector = '.pswp__button--arrow--right'

        slidePhoto.on('keydown', (e) => {
          if (e.keyCode === keys.enter || e.keyCode === keys.space) {
            e.preventDefault()

            const productVideoTriggerBtn = $(e.currentTarget).find(productVideoTriggerCls)
            if (productVideoTriggerBtn.length) {
              productVideoTriggerBtn.click()
              $('.modal__close').focus()
            } else {
              zoomImgBtn.click()
              // setTimeout(() => {
              // pswpCloseBtn.focus()
              // }, 400)
            }

          }
        })

        zoomImgBtn.on('focus', () => {
          $('.product__slide.slick-active').addClass('dummy-focus')
          applyAltZoomImg(pswpCloseBtn)
        })

        zoomImgBtn.on('focusout', () => {
          $('.product__slide.slick-active').removeClass('dummy-focus')
        })

        /* control event tab action when zoom thumb image */
        pswpCloseBtn.on('keydown', (e) => {
          if (e.keyCode === keys.tab) {
            e.preventDefault()
            applyNextPrevText()
            if (!e.shiftKey) {
              $(prevBtnSelector).focus()
            } else {
              $(nextBtnSelector).focus()
            }
          }
        })
        $(prevBtnSelector).on('keydown', (e) => {
          if (e.keyCode === keys.tab) {
            e.preventDefault()
            applyNextPrevText()
            if (!e.shiftKey) {
              $(nextBtnSelector).focus()
            } else {
              pswpCloseBtn.focus()
            }
          }
        })
        $(nextBtnSelector).on('keydown', (e) => {
          if (e.keyCode === keys.tab) {
            applyNextPrevText()
            e.preventDefault()
            if (!e.shiftKey) {
              pswpCloseBtn.focus()
            } else {
              $(prevBtnSelector).focus()
            }
          }
        })

        zoomImgBtn.on('click keydown', () => {
          setTimeout(() => {
            applyAltZoomImg(pswpCloseBtn, false)
          }, 600)
          $(prevBtnSelector).attr('aria-label', '')
          $(nextBtnSelector).attr('aria-label', '')
        })
        $('.pswp').on('focus', () => {
          $('.zooming-alt').attr('tabindex', '0').focus()
          $(nextBtnSelector).attr('aria-hidden', 'true')
          $(prevBtnSelector).attr('aria-hidden', 'true')
        })
        $('.zooming-alt').on('focus', () => {
          setTimeout(() => {
            pswpCloseBtn.focus()
          }, 800)
          setTimeout(() => {
            $(nextBtnSelector).attr('aria-hidden', 'false')
            $(prevBtnSelector).attr('aria-hidden', 'false')
          }, 900)
        })

        $(nextBtnSelector).on('keydown click', (e) => {
          const $target = $(e.currentTarget)
          if (e.type === 'click' || e.keyCode === keys.enter) {
            applyAltZoomImg($target)
          }

          if (e.keyCode === keys.space) {
            $(e.currentTarget).click()
          }
          if (e.keyCode === keys.tab) {
            applyNextPrevText()
          }
        })
        $(prevBtnSelector).on('keydown click', (e) => {
          const $target = $(e.currentTarget)
          if (e.type === 'click' || e.keyCode === keys.enter) {
            applyAltZoomImg($target)
          }
          if (e.keyCode === keys.space) {
            $(e.currentTarget).click()
          }
          if (e.keyCode === keys.tab) {
            applyNextPrevText()
          }
        })

        // $('.pswp').attr('aria-label', ' ')
        const applyNextPrevText = () => {
          $(pswpCloseBtn).attr('aria-label', '')
          $(prevBtnSelector).attr('aria-label', '')
          $(nextBtnSelector).attr('aria-label', '')
        }
        const applyAltZoomImg = ($elmNeedAppendTo, focus = true) => {
          const psItem = $('.pswp').find('.pswp__item')
          psItem.each((_i, el) => {
            const $item = $(el)
            setTimeout(() => {
              const $img = $item.find('img').last() // $item.find('.pswp__img').not('.pswp__img--placeholder')
              if ($img.length && isInViewport($img)) {
                const alt = $item.find('img').last().attr('alt') + '.'
                $elmNeedAppendTo.attr('aria-label', alt ? alt : $elmNeedAppendTo.attr('aria-label')) //.addClass('custom-label')
                if (focus) {
                  $elmNeedAppendTo.focus()
                }
                return true
              }
            }, 300)
          })
        }

        const isInViewport = (element) => {
          const rect = element.get(0).getBoundingClientRect();
          return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
            rect.right <= (window.innerWidth || document.documentElement.clientWidth)
          );
        }


        focusLargeImgWhenClosePopup()
      }

      function moveSlide(id) {
        const item = $(`.product__thumb[data-id="${id}"]`)

        if (currentShowItem && currentShowItem.is(item)) {
          return
        }

        currentShowItem = item
        // reset
        thumbBtn.removeClass(currentCls).attr('aria-selected', false)
        thumbBtn.parents(thumbItemCls).hasClass(startingItem) && thumbBtn.parents(thumbItemCls).removeClass(startingItem)
        item.addClass(currentCls).attr('aria-selected', true)

        // set active status
        const activePhoto = $(`${slidePhotoSelector}[data-id="${id}"]`)
        slidePhoto.removeClass(slickActiveCls)
        activePhoto.addClass(slickActiveCls)
        // activePhoto.attr('role', 'presentation')

        // move slide
        const showIndex = +item.parents(thumbItemCls).attr('data-show-index')
        setTabIndexForThumbBtn(item.parents(thumbItemCls).attr('data-show-index'))

        if (showIndex >= totalShowItem - activeScrollNum + 1) {
          slideTrack.css('margin-top', `-${lastActiveItemPos - (thumbBtnHeight * (activeScrollNum)) + 50}px`)
        } else {
          slideTrack.css('margin-top', `-${(showIndex - 1 >= 0 ? showIndex - 1 : 0) * thumbBtnHeight}px`)
        }
      }

      function setTabIndexForThumbBtn(number = 0, init = false, noThumbs = false, controlByInputIndex = false) {
        // const isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1
        const imgWrapSelector = '.image-wrap'

        if (noThumbs) {
          const activePhoto = $(slidePhoto.get(0))
          activePhoto.addClass(slickActiveCls)
          return
        }

        if (controlByInputIndex) {
          slidePhoto.removeClass(slickActiveCls)

          // activeItems.find(productThumbSelector)
          $(productThumbSelector).attr('tabIndex', -1).removeClass(disabledFocusCls).removeClass(currentCls)
          const activeThumb = $($(productThumbSelector).get(number))
          activeThumb.attr('tabIndex', 0).addClass(currentCls)

          const activePhoto = $(slidePhoto.get(number))
          activePhoto.addClass(slickActiveCls)
          return
        }

        const activeItems = $(`.${activeVariantCls}`)
        const allowTabItem = $(activeItems.eq(number))

        activeItems.find(productThumbSelector).attr('tabIndex', -1)
        allowTabItem.find(productThumbSelector).attr('tabIndex', 0)

        const allowTabId = allowTabItem.find(productThumbSelector).data("id")
        let activePhoto
        activePhoto = $(`${slidePhotoSelector}[data-id="${allowTabId}"]`)
        slidePhoto.removeClass(slickActiveCls)

        if (activePhoto.find('.product-video-trigger').length) {
          zoomImgBtn.addClass('hide')
        } else {
          zoomImgBtn.hasClass('hide') && zoomImgBtn.removeClass('hide')
        }

        if (init) {
          setTimeout(() => {
            slidePhoto.removeClass(slickActiveCls)

            activePhoto.addClass(slickActiveCls)
          }, 300)
        } else {
          activePhoto.addClass(slickActiveCls)
        }
      }
    }

    function adaHeader() {
      const $toggleSlideNavButton = $('.js-toggle-slide-nav')
      const $siteNavigation = $('.site-navigation')
      const $siteNavDropdownLinkHasChildren = $('.site-nav__dropdown-link--has-children')
      const $siteHeaderLogoLink = $('.site-header__logo-link')
      const $siteNavIcons = $('.site-nav__icons')
      const $siteNavExpandedItem = $('.site-nav__expanded-item')
      const classIsFocused = 'is-focused'

      if ($toggleSlideNavButton.length) {
        const observer = new MutationObserver(function (mutations) {
          mutations.forEach(function (mutation) {
            if ($(mutation.target).hasClass('is-active')) {
              $(mutation.target).attr('aria-label', 'close menu')
              $siteNavigation.find('a:visible').first().focus()
            } else {
              $(mutation.target).removeAttr('aria-label')
            }
          })
        })
        observer.observe($toggleSlideNavButton.get(0), {
          attributes: true,
          attributeFilter: ['class']
        })

        $toggleSlideNavButton.on('keydown', function (e) {
          const code = e.keyCode || e.which
          if (code === 9 && !e.shiftKey) {
            const $navLink = $siteNavigation.find('a:visible')
            if ($navLink.length) {
              e.preventDefault()
              setTimeout(() => {
                $navLink.first().focus()
              }, 100)
            }
          }
        })

        $siteHeaderLogoLink.on('keydown', function (e) {
          if (window.innerWidth <= 768) {
            const code = e.keyCode || e.which
            if (code === 9 && !e.shiftKey) {
              e.preventDefault()
              $siteNavIcons.find('a:visible').first().focus()
            }
          }
        })

        $siteNavIcons.find('a:visible').first().on('keydown', function (e) {
          if (window.innerWidth <= 768) {
            const code = e.keyCode || e.which
            if (code === 9 && e.shiftKey) {
              e.preventDefault()
              $siteHeaderLogoLink.focus()
            }
          }
        })

        $siteNavDropdownLinkHasChildren.on('focus', function () {
          if (window.innerWidth <= 768 && $('html').hasClass('tab-outline')) {
            $(this).parents('.site-nav__deep-dropdown-trigger').addClass('is-show-child')
          }
        })

        $siteNavigation.on('keydown', 'a', function (e) {
          if (window.innerWidth <= 768) {
            const code = e.keyCode || e.which
            const $navLink = $siteNavigation.find('a:visible')
            const $firstNavLink = $navLink.first()
            const $lastNavLink = $navLink.last()
            const indexCurrent = findIndex($navLink, $(this))

            switch (code) {
              case 9:
                if (e.shiftKey && $(this).is($firstNavLink)) {
                  e.preventDefault()
                  $toggleSlideNavButton.focus()
                } else if ($(this).is($lastNavLink)) {
                  e.preventDefault()
                  $firstNavLink.focus()
                }
                break
              case 40:
                e.preventDefault()
                if (indexCurrent !== -1 && indexCurrent + 1 < $navLink.length) {
                  $navLink.get(indexCurrent + 1).focus()
                } else {
                  $firstNavLink.focus()
                }
                break
              case 38:
                e.preventDefault()
                if (indexCurrent !== -1 && indexCurrent - 1 >= 0) {
                  $navLink.get(indexCurrent - 1).focus()
                } else {
                  $lastNavLink.focus()
                }
                break
              default:
                break
            }
          }
        })
      }

      $(document).on('keydown', function (e) {
        if (window.innerWidth > 768) {
          const code = e.keyCode || e.which
          if (code == 27) {
            $siteNavExpandedItem.find('>a:first-child').focus()
            setTimeout(() => {
              $siteNavExpandedItem.removeClass(classIsFocused)
              $siteNavExpandedItem.find('.is-focused').removeClass(classIsFocused)
            }, 25)
          }
        }
      })

      $siteNavExpandedItem.find('>a:first-child').on('keydown', function (e) {
        if (window.innerWidth > 768) {
          const code = e.keyCode || e.which
          if (code == 32) {
            e.preventDefault()
            $siteNavExpandedItem.find('.is-focused').removeClass(classIsFocused)
            if ($siteNavExpandedItem.hasClass(classIsFocused)) {
              setTimeout(() => {
                $siteNavExpandedItem.find('>a:first-child').focus()
              }, 1)
              setTimeout(() => {
                $siteNavExpandedItem.removeClass(classIsFocused)
                $siteNavExpandedItem.find('.is-focused').removeClass(classIsFocused)
                $siteNavExpandedItem.find('.uw-active').removeClass('uw-active')
              }, 2)
            } else {
              $siteNavExpandedItem.addClass(classIsFocused)
            }
          } else if (code === 9 && e.shiftKey) {
            $siteNavExpandedItem.removeClass(classIsFocused)
            $siteNavExpandedItem.find('.is-focused').removeClass(classIsFocused)
            $siteNavExpandedItem.find('.uw-active').removeClass('uw-active')
          }
        }
      })
    }

    function adaProductCategories() {
      const $catItem = $('.index-section--collections .skrim__link')

      $catItem.on('focus', function () {
        $(this).parents('.skrim__item').addClass('focused')
      }).on('blur', function () {
        $(this).parents('.skrim__item').removeClass('focused')
      })
    }

    function findIndex($list, $el) {
      for (let index = 0; index < $list.length; index++) {
        if ($list.eq(index).is($el)) {
          return index
        }
      }
      return -1
    }

    function handleCloseDialogs() {
      const $modalClose = $('.modal--square .js-modal-close')
      $modalClose.on('keydown', (e) => {
        const code = e.keyCode || e.which
        if (code === 32 || code === 13) {
          e.preventDefault()
          $('.modal--square').removeClass('modal--is-active')
          $('body, html').removeClass('modal-open')
          $('html').attr('tabindex', '10')
          $('html').focus()
        }
      })
    }

    function handleDialogs() {
      const $modalSquare = $('.modal--square')
      if ($modalSquare.length) {
        const observer = new MutationObserver(function (mutations) {
          mutations.forEach(function (mutation) {
            if ($(mutation.target).hasClass('modal--is-active')) {
              $(mutation.target).find('#Email-newsletter-popup').focus()
            }
          })
        })
        observer.observe($modalSquare.get(0), {
          attributes: true,
          attributeFilter: ['class']
        })
      }
    }

    function adaTabProduct() {
      const $tabList = $('.collapsibles-wrapper[role="tablist"]')

      if ($tabList.length) {
        const $tab = $tabList.find('button[role="tab"]')
        const moveToTab = (index) => {
          let newIndex = index
          if (newIndex < 0) {
            newIndex = $tab.length - 1
          } else if (newIndex >= $tab.length) {
            newIndex = 0
          }

          $tab.attr('tabindex', -1).attr('aria-selected', false)
          $tab.eq(newIndex).trigger('click').focus()
        }

        $tab.on('keydown', function (e) {
          const code = e.keyCode || e.which
          const index = $(this).index()
          switch (code) {
            case 39:
              e.preventDefault()
              moveToTab(index + 1)
              break
            case 37:
              e.preventDefault()
              moveToTab(index - 1)
              break
            case 36:
              e.preventDefault()
              moveToTab(0)
              break
            case 35:
              e.preventDefault()
              moveToTab($tab.length - 1)
              break
            default:
              break
          }
        }).on('click', function () {
          $tab.attr('tabindex', -1).attr('aria-selected', false)
          $(this).attr('tabindex', 0).attr('aria-selected', true)
        })
      }
    }

    function productFormADA() {
      const priceBox = $('.js-product-price-box');
      const $radioBox = priceBox.find('[type="radio"]')
      $radioBox.on('focus', function () {
        setTimeout(() => {
          $('[aria-live="polite"]').not('.product-single__prices').removeAttr('aria-live')
        }, 100)
      })
    }

    function singleForm() {
      const $singleArea = $('.product-single__meta')
      const inter = setInterval(() => {
        const $form = $singleArea.find('.product-single__form .rc-template__legacy-radio')
        if ($form.length) {
          clearInterval(inter)
          const $label = $form.find('label')
          $form.find('input').attr('tabindex', '-1')
          $label.find('*').attr('tabindex', '-1')
          $label.on('keydown', (ev) => {
            const $target = $(ev.currentTarget)
            const key = ev.keyCode || ev.which
            const keys = [13, 32]
            if (keys.includes(key)) {
              ev.preventDefault()
              $target.find('span').click()
              setTimeout(() => {
                $target.focus()
              }, 50)
            }
          })
          $label.each((_i, el) => {
            $(el).not('.rc-selling-plans label').attr('tabindex', '0').attr('role', 'textbox').attr('aria-label', $(el).text())
          })
        }
      }, 500)
    }

    function faqsADA() {
      const $sectionFaq = $('.index-section--faq .rte')
      $sectionFaq.find('p').each((_i, elm) => {
        $(elm).find('a').removeAttr('title')
        $(elm).find('strong').next().remove()
        $(elm).find('strong').replaceWith('<h3>' + $(elm).find('strong').html() + '</h3>')
        $(elm).append('<p>' + $(elm).clone().children().remove().end().text() + '</p>');
        $(elm).contents().filter((_i, el) => el.nodeType === 3).remove();
        $(elm).replaceWith('<div>' + $(elm).html() + '</div>')
      })
    }

    function bannerHeroADA() {
      const $heroBanner = $('.slideshow-wrapper.hero-wrapper')
      const $heroBannerSlider = $heroBanner.find('.hero-slider')
      const $btnToggle = $heroBanner.find('.slideshow__pause')

      if ($heroBanner.length) {
        $btnToggle.on('click', function () {
          $(this).attr('aria-label', $(this).hasClass('is-paused') ? 'Play' : 'Pause')
        })

        $('.slideshow-wrapper.hero-wrapper .slick-dots [tabindex="0"]').attr('tabindex', -1)

        $heroBanner.on('keydown', '.slick-arrow', function (e) {
          const code = e.keyCode || e.which
          if (code === 37) {
            e.preventDefault()
            if (typeof $heroBannerSlider.slick === 'function') {
              $heroBannerSlider.slick('slickPrev')
            }
          } else if (code === 39) {
            e.preventDefault()
            if (typeof $heroBannerSlider.slick === 'function') {
              $heroBannerSlider.slick('slickNext')
            }
          }
        })

        $heroBannerSlider.on('beforeChange', () => {
          setTimeout(() => {
            const $slickDots = $heroBannerSlider.find('.slick-dots')
            $slickDots.find('> li').attr('aria-hidden', true).removeAttr('aria-controls')
            $slickDots.removeAttr('role')
            $slickDots.find('*').removeAttr('role')
            $heroBannerSlider.removeAttr('role')
            $heroBannerSlider.find('.slideshow__slide[role="option"]').attr('role', 'tabpanel')
          }, 350);
        });

        const observer = new MutationObserver(function (mutations) {
          mutations.forEach(function (mutation) {
            if ($(mutation.target).hasClass('slick-initialized')) {
              $('.slideshow-wrapper.hero-wrapper .slick-dots [tabindex="0"]').attr('tabindex', -1)
            }
          })
        })
        observer.observe($heroBanner.find('.hero-slider').get(0), {
          attributes: true,
          attributeFilter: ['class']
        })
      }
    }

    function testimonialADA() {
      const $sectionTestimonials = $('.index-section--testimonials')
      const $testimonialsSlider = $sectionTestimonials.find('.testimonials-slider')

      if ($sectionTestimonials.length) {
        $testimonialsSlider.on('beforeChange', () => {
          changeRoleSlider($testimonialsSlider, $testimonialsSlider.find('.slick-dots'), '.testimonials-slide__item')
        });

        $testimonialsSlider.on('keydown', '.slick-dots button', function (e) {
          controlDots(e, $testimonialsSlider)
        })
      }
    }

    function productMainPhotoSliderADA() {
      const $productMainPhotos = $('.product__main-photos');
      const $productMainPhotosSlider = $productMainPhotos.find('[data-product-photos]');

      if ($productMainPhotos.length) {
        const target = $productMainPhotosSlider.get(0);

        let observer = new MutationObserver(() => {
          if ($(target).hasClass('slick-initialized')) {
            $(target).closest('.product__main-photos').find('.slick-dots li').removeAttr('aria-hidden');
          }
        });

        observer.observe(target, {
          attributes: true,
          attributeFilter: ['class']
        });
      }
    }

    function collectionSliderADA() {
      const $overflowScrollerCollection = $('.overflow-scroller__collection')
      if ($overflowScrollerCollection.length) {
        $overflowScrollerCollection.on('beforeChange', '.grid-collection', function () {
          changeRoleSlider($(this), $(this).find('.slick-dots'), '.grid-product')
        });

        $overflowScrollerCollection.on('keydown', '.slick-dots button', function (e) {
          const $gridCollection = $(this).parents('.grid-collection')
          controlDots(e, $gridCollection)
        })

        $overflowScrollerCollection.on('beforeChange', '.product-slider', function () {
          setTimeout(() => {
            $(this).find('.product-slide[role="option"]').attr('role', 'tabpanel')
          }, 350);
        })
      }
    }

    function configTabindex() {
      const $heroSubtitle = $('.hero-natural-banner .hero__subtitle')
      const $scrollerCollection = $('.overflow-scroller__collection')
      const $heroMedia = $('.hero__media')
      $heroSubtitle.each((_i, elm) => {
        $(elm).attr('tabindex', '-1');
      })
      $scrollerCollection.attr('tabindex', '-1');
      $heroMedia.find('video').attr('tabindex', '-1');
    }

    function productImageADA() {
      const $imgThumbs = $('.product__thumb')
      $imgThumbs.on('focus', function () {
        $('[aria-live="polite"]').not('.product-single__prices').removeAttr('aria-live')
      })

      const $mainSliderWrapper = $('.product__main-photos')
      if ($mainSliderWrapper.length) {
        $mainSliderWrapper.on('beforeChange', '[data-product-photos]', function () {
          changeRoleSlider($(this), $mainSliderWrapper.find('.product__photo-dots'), '.product__slide')
        });

        $mainSliderWrapper.on('keydown', '.slick-dots button', function (e) {
          const $mainSlider = $mainSliderWrapper.find('[data-product-photos]')
          controlDots(e, $mainSlider)
        })
      }
    }

    function loginForm() {
      const $customerLoginForm = $('#CustomerLoginForm')
      if ($customerLoginForm.length) {
        const observer = new MutationObserver(function (mutations) {
          mutations.forEach(function (mutation) {
            $(mutation.target).find('#rc_login h5').replaceWith(function () {
              return $("<p />", {
                html: $(this).html()
              })
            });
          })
        })
        observer.observe($customerLoginForm.get(0), {
          childList: true,
          subtree: true
        })
      }
    }

    function changeAlt() {
      const $btnZoom = $('.product__photo-zoom')
      $btnZoom.attr('aria-label', $('.product__main-photos-wrapper .slick-active img').attr('alt'))
      $btnZoom.attr('tabindex', '0')
    }

    function productADA() {
      const $productThumb = $('.product__thumb-item')
      setTimeout(() => {
        changeAlt()
      }, 1000);
      $productThumb.find('a').on('focus', () => {
        changeAlt()
      })
      $productThumb.on('click', () => {
        changeAlt()
      })
    }

    function shiftTabScrollUp() {
      $(document).on('focus', '.main-content [tabindex="0"], .main-content a, .main-content button, .main-content [role="button"], .main-content input', (e) => {
        if (e.currentTarget.getBoundingClientRect().top < 150) {
          $(window).scrollTop($(e.currentTarget).offset().top - 150)
        }
      })

      $('.slick-slider a, .slick-slider button, .slick-slider [tabindex="0"], .slick-slider [role="button"]').on('focus', (e) => {
        if ($(e.currentTarget).parents('.product__thumbs--beside').length) {
          setTimeout(() => {
            $('.product__thumbs--beside .slick-list').scrollTop(0)
          }, 50)
        }
        if (e.currentTarget.getBoundingClientRect().top < 150) {
          $(window).scrollTop($(e.currentTarget).offset().top - 150)
        }
      })
    }

    function controlDots(e, $slider) {
      const code = e.keyCode || e.which
      if (code === 37) {
        e.preventDefault()
        if (typeof $slider.slick === 'function') {
          $slider.slick('slickPrev')
        }
      } else if (code === 39) {
        e.preventDefault()
        if (typeof $slider.slick === 'function') {
          $slider.slick('slickNext')
        }
      }
    }

    function changeRoleSlider($slider, $dots, selectorSlideItem) {
      setTimeout(() => {
        $dots.removeAttr('role')
        $dots.find('*').removeAttr('role')
        $dots.find('[aria-hidden]').removeAttr('aria-hidden')
        $slider.removeAttr('role')
        $slider.find(`${selectorSlideItem}[role="option"]`).attr('role', 'tabpanel')
      }, 550);
    }

    function handleReadPrice() {
      // Detect Safari
      $('.safari .js-product-price-box').first().find('.variant-input').on('keydown', () => {
        handleTabLasersSize()
      })
    }

    function handleTabLasersSize() {
      const characSpecial = '&nbsp;';
      const $priceCompare = $('.product__price--compare');
      if ($priceCompare.length) {
        let $priceHidden = $('.price-hidden1');
        if (!$priceHidden.length) {
          $priceCompare.parent().next().before(`<span class="price-hidden1 visually-hidden">&nbsp;</span>`).after(`<span class="price-hidden2 visually-hidden">&nbsp;</span>`);
        }
        const salePrice = $('.product__price--compare').parent().nextAll('.visually-price');
        if (flagCount > 0) {
          $('.price-hidden1').html('');
          $('.price-hidden2').html('');
          $(salePrice).html(`${salePrice.html()} ${characSpecial}`);
          flagCount = 0
        } else {
          flagCount++;
          $('.price-hidden1').html('&nbsp;');
          $('.price-hidden2').html('&nbsp;');
          $(salePrice).html(`${salePrice.html().split(characSpecial)[0]}`);
        }
      }
    }

    function browserDetection() {
      const $html = $('html');
      const isExplorer = (navigator.userAgent.indexOf('MSIE') || navigator.userAgent.indexOf('rv:15')) > -1
      const isFirefox = navigator.userAgent.indexOf('Firefox') > -1
      const isSafari = navigator.userAgent.indexOf('Safari') > -1
      const isChrome = navigator.userAgent.indexOf('Chrome') > -1
      if (isExplorer || document.documentMode) {
        $html.addClass('ie')
      }
      if (isFirefox) {
        $html.addClass('firefox')
      }
      if (isChrome && isSafari) {
        $html.addClass('chrome')
      }
      if (!isChrome && isSafari) {
        $html.addClass('safari')
      }
      if (/Edge/.test(navigator.userAgent)) {
        $html.addClass('edge')
      }
    }

    function toggleOneTrust() {
      $('.ot-sdk-show-settings, .open-onetrust').on('click keydown', (e) => {
        if (e.type === 'click' || (e.type === 'keydown' && e.keyCode === 13)) {
          window.OneTrust.ToggleInfoDisplay()
          $('body').removeClass('unloading')
          setTimeout(function () {
            $('body').removeClass('unloading')
          }, 100)
        }
      })
    }
    function goToAnchorLink() {
      $(document).on('click keydown', 'a', (e) => {
        const href = $(e.currentTarget).attr('href')
        if (href.indexOf('#') === 0 && (e.type === 'click' || (e.type === 'keydown' && e.keyCode === 13))) {
          e.preventDefault()
          $('html, body').animate({
            scrollTop: $(href).offset().top - $('.header-wrapper').outerHeight() - 20
          }, 400)
        }
      })
    }

    init()
  }


  $(document).ready(function () {
    themeADA.initADA()
  });

})(theme.jQuery)
